import { Loader2Icon } from 'lucide-react'
import type { FC, KeyboardEvent, ReactNode, RefObject } from 'react'

import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

export interface InlineEditableTextInputProps {
  inputRef: RefObject<HTMLInputElement | null>
  draftValue: string
  isLoading: boolean
  maxLength: number
  className?: string
  inputClassName?: string
  onDraftChange: (value: string) => void
  onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void
  onBlur: () => void
}

/**
 * Input state of the inline editable text component.
 */
export const InlineEditableTextInput: FC<InlineEditableTextInputProps> = ({
  inputRef,
  draftValue,
  isLoading,
  maxLength,
  className,
  inputClassName,
  onDraftChange,
  onKeyDown,
  onBlur,
}): ReactNode => (
  <div className={cn('inline-editable-text-input-wrapper flex items-center gap-1', className)}>
    <Input
      ref={inputRef}
      value={draftValue}
      onChange={(e) => onDraftChange(e.target.value)}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      disabled={isLoading}
      maxLength={maxLength}
      className={cn('inline-editable-text-input h-7 text-sm', inputClassName)}
      aria-label="Edit name"
    />
    {isLoading && <Loader2Icon className="size-4 shrink-0 animate-spin text-muted-foreground" />}
  </div>
)

InlineEditableTextInput.displayName = 'InlineEditableTextInput'
